<template>
    <div
            class="d-flex flex-column"
            :class="{'shadow-lg': over, 'shadow-sm': !over}"
            style="margin-bottom: 10px; border: 1px solid rgba(211,211,211,0.37); border-radius: 5px;"
            v-on:mouseenter="over = true"
            v-on:mouseleave="over = false"
    >
        <div
                class="row"
                :style="{'height': height}"
                style="width: 100%; margin-bottom: 10px; position: relative;"
        >
            <div class="col-md-2">
                <img
                        :id="'img_' + id"
                        class="image"
                        v-if="show_image"
                        :src="image_source == 'none'?image_source:'./src/assets.logo.png'"
                        :style="{'height': height}"
                />
            </div>
            <div class="col-md-10">
                <div class="row">


                    <div class="col-md-2 d-flex flex-column">
                        <div v-if="show_sharing">
                            <i class="fas fa-share-alt-square"></i>
                        </div>

                        <div v-if="show_campaign"><h6 class="text-muted">{{campaign}}</h6></div>

                        <div v-if="show_name">
                            <h4>{{name}}</h4>
                        </div>

                        <div v-if="show_product_name">
                            <h4>{{product_name}}</h4>
                        </div>

                        <div v-if="show_subtitle">
                            <h5 class="text-muted">{{subtitle}}</h5>
                        </div>

                        <div v-if="show_end_date">
                            <h5>{{format_date(end_date)}}</h5>
                        </div>
                        <div v-if="show_views">
                            <h6 class="text-muted">views: {{views}}</h6>
                        </div>
                    </div>

                    <div class="col-md-2 d-flex flex-row align-items-center">
                        <div v-if="show_count_of_joined">
                            <i class="fas fa-users" style="font-size: 1.4rem; margin-right: 4px;"></i>
                            <span class="text-muted">
                                {{count_of_joined}}
                            </span>
                        </div>
                    </div>

                    <div class="col-md-1 d-flex flex-row align-items-center">
                        <div v-if="show_quantity">
                            Quantity <input type="number" v-model="computed_quantity" style="width: 100%;" autocomplete="new-password">
                        </div>
                    </div>

                    <div class="col-md-3 d-flex flex-row align-items-center">
                        <div v-if="show_orig_cost" style="padding-right: 10px;">
                            <h4 style="text-decoration: line-through;">${{orig_cost}}</h4>
                        </div>

                        <div v-if="show_cost">
                            <h4>${{cost}}</h4>
                        </div>
                    </div>



                    <div class="col-md-4 d-flex flex-row justify-content-between align-items-center">
                        <div v-show="!over"></div>
                        <div v-show="over" style="width: 100%;">
                            <div class="d-flex flex-row justify-content-around align-items-center">
                                <div>
                                    <ks-button v-if="button_action === 'add_to_cart'" :label="button_text" @onClick="onClick()"></ks-button>
                                    <router-link v-else-if="button_action === 'link'" class="nav-link" :to="{ path: url}">
                                        <ks-button :label="button_text"></ks-button>
                                    </router-link>
                                </div>
                                <div v-if="show_second_button">
                                    <ks-button v-if="second_button_action === 'add_to_cart'" :color="'secondary'" :label="second_button_text" @onClick="onClick()"></ks-button>
                                    <router-link v-else-if="second_button_action === 'link'" class="nav-link" :to="{ path: second_url}">
                                        <ks-button :label="second_button_text" :color="'secondary'"></ks-button>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>





        </div>
        <div v-if="show_percent_joined" style="height: 10px;"
             :class="{'green': percent_joined == 100, 'yellow': percent_joined < 100}"
             :style="{'width': percent_joined + '%'}"></div>
    </div>
</template>

<script>
    import KsButton from "../button/index";
    import format_date from "../../mixins/formatDate";
    export default {
        /**
            tag
            name: ks-product-banner
            description: product banner
        **/
        name: "product_banner",
        components: {KsButton},
        props: {
            /**
                attribute
                name: id 
                description: id
            **/
            id: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: height 
                description: height
            **/
            height: {
                type: String,
                default: "auto"
            },
            /**
                attribute
                name: count_of_joined 
                description: count_of_joined
            **/
            count_of_joined: {
                type: Number,
                default: 0
            },
            /**
                attribute
                name: show_count_of_joined 
                description: show_count_of_joined
            **/
            show_count_of_joined: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: image_source 
                description: image_source
            **/
            image_source: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_image 
                description: show_image
            **/
            show_image: {
                type: Boolean,
                default: true
            },
            /**
                attribute
                name: percent_joined 
                description: percent_joined
            **/
            percent_joined: {
                type: Number,
                default: 0
            },
            /**
                attribute
                name: show_percent_joined 
                description: show_percent_joined
            **/
            show_percent_joined: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: orig_cost 
                description: orig_cost
            **/
            orig_cost: {
                type: String,
                default: '0.00'
            },
            /**
                attribute
                name: show_orig_cost 
                description: show_orig_cost
            **/
            show_orig_cost: {
                type: Boolean,
                default: true
            },
            /**
                attribute
                name: cost 
                description: cost
            **/
            cost: {
                type: String,
                default: '0.00'
            },
            /**
                attribute
                name: show_cost 
                description: show_cost
            **/
            show_cost: {
                type: Boolean,
                default: true
            },
            /**
                attribute
                name: quantity 
                description: quantity
            **/
            quantity: {
                type: Number,
                default: 1
            },
            /**
                attribute
                name: show_quantity 
                description: show_quantity
            **/
            show_quantity: {
                type: Boolean,
                default: true
            },
            /**
                attribute
                name: name 
                description: name
            **/
            name: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_name 
                description: show_name
            **/
            show_name: {
                type: Boolean,
                default: true
            },
            /**
                attribute
                name: campaign 
                description: campaign
            **/
            campaign: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_campaign 
                description: show_campaign
            **/
            show_campaign: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: end_date 
                description: end_date
            **/
            end_date: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_end_date 
                description: show_end_date
            **/
            show_end_date: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: views 
                description: views
            **/
            views: {
                type: Number,
                default: 0
            },
            /**
                attribute
                name: show_views 
                description: show_views
            **/
            show_views: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: show_sharing 
                description: show_sharing
            **/
            show_sharing: {
                type: Boolean,
                default: true
            },
            /**
                attribute
                name: subtitle 
                description: subtitle
            **/
            subtitle: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_subtitle 
                description: show_subtitle
            **/
            show_subtitle: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: product_name 
                description: product_name
            **/
            product_name: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_product_name 
                description: show_product_name
            **/
            show_product_name: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: show_second_button 
                description: show_second_button
            **/
            show_second_button: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: second_button_text 
                description: second_button_text
            **/
            second_button_text: {
                type: String,
                default: "Add"
            },
            /**
                attribute
                name: second_button_action 
                description: second_button_action
            **/
            second_button_action: { type: String, default: "link" }, // add_to_cart, go_to_products_url
            /**
                attribute
                name: button_text 
                description: button_text
            **/
            button_text: {
                type: String,
                default: "Add"
            },
            /**
                attribute
                name: button_action 
                description: button_action
            **/
            button_action: { type: String, default: "add_to_cart" }, // add_to_cart, go_to_products_url
            /**
                attribute
                name: url 
                description: url
            **/
            url: { type: String, default: null },
            /**
                attribute
                name: second_url 
                description: second_url
            **/
            second_url: { type: String, default: null }
        },
        mixins: [format_date],
        methods: {
            onClick() {
                this.$emit('onClick', this.id);
            },

        },
        data: function () {
            return {
                over: false,
            }
        },
        computed: {
            computed_quantity: {
                get: function() {
                    return this.quantity;
                },
                set: function(new_quantity) {
                    this.$emit('update_quantity', {"id":this.id, "quantity": new_quantity});
                }
            }
        }
    }
</script>
<style>
    .green {
        background: green;
    }

    .yellow {
        background: yellow;
    }
</style>
